import React, { useState, useEffect } from 'react';
import { Button, Form, Container, Row, Col, Card } from 'react-bootstrap';
import { Send as SendIcon } from '@mui/icons-material';
import VerifyOtp from './VerifyOtp';
import Phone from '../Assets/phone.png';
import { postDatatoServer } from '../utils/apiBase';
import toast from 'react-hot-toast';
import Cookies from 'js-cookie';
import { Link, useNavigate } from 'react-router-dom';
import ContextHelper from '../ContextHooks/ContextHelper';

const OtpVerification = () => {
  const [mobileNumber, setMobileNumber] = useState('+91');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [oneTimePassword, setOneTimePassword] = useState('');
  const [formValues, setFormValues] = useState({ mobile: '' });
  const [otpResendSeconds, setOtpResendSeconds] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const navigate = useNavigate();
  const token = Cookies.get('patient_token');
  const { currentUser } = ContextHelper();

  useEffect(() => {
    if (token) {
      navigate('/patient-report');
    }
  }, [token, navigate]);

  useEffect(() => {
    if (currentUser?.token) {
      navigate(currentUser?.isadmin ? '/add-report' : '/view-report');
    }
  }, [currentUser, navigate]);

  const handleMobileSubmit = (e) => {
    e.preventDefault();

    if (mobileNumber.length === 13) {
      setFormValues({ mobile: mobileNumber });
      setOtpResendSeconds(60);

      const body = { mobileNumber: mobileNumber };

      postDatatoServer({
        end_point: 'checkMobileNumber',
        body: body,
        call_back: (result) => {
          if (result.status === 'success') {
            setIsOtpSent(true);
            toast.success('OTP sent successfully');
          } else {
            setIsOtpSent(false);
            toast.error('Mobile number not found, please register.');
          }
        },
      });
    } else {
      setFormErrors({ mobile: 'Please enter a valid 10-digit mobile number.' });
    }
  };

  const handleNumericInput = (e) => {
    let value = e.target.value;
    if (!value.startsWith('+91')) {
      value = '+91' + value.replace(/\D/g, '');
    } else {
      value = '+91' + value.substring(3).replace(/\D/g, '');
    }
    setMobileNumber(value);
    setFormErrors((prevErrors) => ({ ...prevErrors, mobile: '' }));
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const body = {
      username: formValues.mobile,
      otp: oneTimePassword,
      type: 'patient',
    };

    postDatatoServer({
      end_point: 'varify-otp',
      body: body,
      call_back: (result) => {
        setLoading(false);
        if (result.status === 'success') {
          Cookies.set('patient_token', result.response.token, { expires: 30, path: '/' });
          localStorage.setItem('current_user', JSON.stringify({ token: result?.response?.token }));
          localStorage.setItem('token', result?.response?.token);
          toast.success('OTP verified successfully!');
          navigate('/patient-report');
        } else {
          toast.error('OTP verification failed!');
        }
      },
    });
  };

  const handleOtp = () => {
    setIsOtpSent(false);
    setOtpResendSeconds(60);
  };

  function handleResendOTP(e) {
    handleOtp();
    setOneTimePassword(null);
    setOtpResendSeconds(60);
    handleMobileSubmit(e);
  }

  useEffect(() => {
    if (otpResendSeconds > 0) {
      const interval = setInterval(() => {
        setOtpResendSeconds((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [otpResendSeconds]);

  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-100">
      <Row className="justify-content-center w-100">
        <Col lg={6} md={8} sm={10}>
          <Card className="shadow-lg border-0 rounded-lg">
            <Card.Body className="p-5">
              {!isOtpSent ? (
                <Form onSubmit={handleMobileSubmit}>
                  <h2 className="text-center mb-4">Mobile Verification</h2>
                  <div className="mb-4 text-center">
                    <img src={Phone} className="img-fluid" width={65} alt="phone" />
                  </div>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text">+91</span>
                      <Form.Control
                        type="tel"
                        placeholder="Enter your mobile number"
                        value={mobileNumber.slice(3)}
                        onChange={handleNumericInput}
                        isInvalid={!!formErrors.mobile}
                        maxLength={10}
                        className="form-control-lg"
                      />
                    </div>
                    <Form.Control.Feedback type="invalid">{formErrors.mobile}</Form.Control.Feedback>
                  </Form.Group>
                  <div className="d-grid">
                    <Button
                      variant="primary"
                      type="submit"
                      className="login-btn base-color-bg text-white fw-semibold px-5 btn-lg"
                      disabled={mobileNumber.replace(/\D/g, '').length !== 12}
                    >
                      <SendIcon style={{ marginRight: '8px' }} />
                      Send OTP
                    </Button>
                    <div className="mt-3 fs-6 text-center">
                      <Link to="/login" className="text-decoration-none fs-18 fw-semibold">
                        Login
                      </Link>
                    </div>
                  </div>
                </Form>
              ) : (
                <VerifyOtp
                  oneTimePassword={oneTimePassword}
                  handleResendOTP={handleResendOTP}
                  handleSubmit={handleOtpSubmit}
                  formValues={formValues}
                  otpResendSeconds={otpResendSeconds}
                  setOtpResendSeconds={setOtpResendSeconds}
                  loading={loading}
                  setOneTimePassword={setOneTimePassword}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default OtpVerification;
